import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { PropTypes } from 'prop-types';

const styles = {
  container: {
    padding: 'xxxlarge',
    textAlign: 'center',
    fontColor: 'lowContrast'
  },
  text: {
    padding: 'medium'
  }
};

export default function Loading({ message }) {
  return (
    <UX2.Element.Block style={ styles.container }>
      <UX2.Element.Loader size='medium' />
      <UX2.Element.Text children={ message } />
    </UX2.Element.Block>
  );
}

Loading.propTypes = {
  message: PropTypes.string
};
